import React, { useState } from 'react';
import styles from '@styles/screens/ConfiguracionScreen.module.css';
import { ReactComponent as ArrowRightSVG } from '@assets/SVGs/Configuracion/ArrowRight.svg';
import { useNavigate, Navigate } from 'react-router-dom';
import { Organization } from '@models/Organization';
import { Loader } from '@shared/designSystem/Loader';

export interface ListScreenItem {
	path: string;
	state?: any;
	label: string;
	SvgComponent: React.FC<any>;
}

interface ListScreenProps {
	title: string;
	org: Organization;
	loading?: boolean;
	onScreenClick?: (screen: ListScreenItem) => void;
	screens: ListScreenItem[];
	footer?: React.ReactNode;
}

const ListScreen: React.FC<ListScreenProps> = ({ title, org, loading, onScreenClick, screens, footer }) => {
	return (
		<div className={styles['content-block']}>
			<div className={styles['header-container']}>
				<div className={styles['title-container']}>
					<h2 className={styles['title']}>{title}</h2>
				</div>
			</div>
			<div className={styles['content-container']}>
				{loading && (
					<div
						style={{
							display: 'flex',
                            width: '100%',
                            height: '100%',
							justifyContent: 'center',
							alignItems: 'center',
						}}>
						<Loader height="80px" width="80px" />
					</div>
				)}
				{screens.map((screen, index) => {
					return (
						<div
							className={styles['option-container']}
							onClick={() => onScreenClick && onScreenClick(screen)}
							key={index}>
							<div className={styles['option']}>
								<div className={styles['option-svg']}>
									<screen.SvgComponent />
								</div>
								{screen.label}
							</div>
							<div className={styles['option-svg']}>
								<ArrowRightSVG />
							</div>
						</div>
					);
					})}
				</div>
				{footer && <div className={styles['footer-container']}>{footer}</div>}
			</div>
		);
};

interface ListScreenWrapperProps {
	org: Organization;
	title: string;
	loading?: boolean;
	onScreenClick?: (screen: ListScreenItem) => void;
	screens: ListScreenItem[];
	footer?: React.ReactNode;
}

const ListScreenWrapper: React.FC<ListScreenWrapperProps> = ({
	org,
	title,
	loading,
	onScreenClick,
	screens,
	footer,
}) => {
	if (!org.newFlags?.QontactPointCreationWeb) {
		return <Navigate to="/" />;
	}

	return (
		<ListScreen
			title={title}
				org={org}
				loading={loading}
				onScreenClick={onScreenClick}
				screens={screens}
				footer={footer}
			/>
	);
};

export default ListScreenWrapper;
